import LabelsCell from 'routes/ChapterList/LabelsCell/LabelsCell';

export default LabelsCell;
